import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { slideInOutAnimation } from 'src/app/route-animations';
import { SHARED_IMPORTS } from '../../shared/standalone-imports';

@Component({
  selector: 'app-thank-you-accept',
  templateUrl: './thank-you-accept.component.html',
  styleUrls: ['./thank-you-accept.component.scss'],
  animations: [slideInOutAnimation],
  host: { '[@slideInOutAnimation]': '' },
  standalone: true,
  imports: [...SHARED_IMPORTS],
})
export class ThankYouAcceptComponent implements OnInit {

  constructor(private readonly router: Router) { }

  public ngOnInit(): void {
    localStorage.setItem('state', '/bedankt-accepteren');
  }

  public nextStep() {
    localStorage.setItem('state', '/informatie-aanleveren');
    this.router.navigate(['/verificatie']);
  }
}
